import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { MiniLetterViewer } from '../LetterViewer';
import EditorContext from './EditorContext';

export const SideCar = () => {
  const { letterId } = useContextSelector(EditorContext, (ctx) => ctx.sideCar);

  if (letterId) {
    return <MiniLetterViewer key={letterId} letterId={letterId} />;
  } else {
    return <></>;
  }
};
